import login from './login'
import loan from './loan'
import supplement from './supplement'
import repay from './repay'
import apply from './apply'
import protocol from './protocol'
import user from './user'
import question from './question'
import coupons from './coupons'
import extension from './extension'
import daoliu from './daoliu'
export default [
    // 登录页面路由
    login,
    {
        path: '/',
        redirect: {
            name: 'index'
        }
    },
    {
        name: 'index',
        path: '/index',
        meta: {
            needLogin: true
        },
        component: () => import('@/view/user/profile-v2.vue')
    },
    {
        name: 'index/result',
        path: '/index/result',
        meta: {
            needLogin: true
        },
        component: () => import('@/view/index-result.vue')
    }, {
        name: 'bank/valid',
        path: '/bank/valid',
        meta: {
            needLogin: true
        },
        component: () => import('@/view/bank-valid.vue')
    }, {
        name: 'cmbc',
        path: '/cmbc',
        meta: {
            needLogin: true
        },
        component: () => import('@/view/cmbc.vue')
    }, {
        name: 'loan/contract',
        path: '/loan/contract/:contractType',
        component: () => import('@/view/contract.vue')
    },
    {
        name: 'redirect/status',
        path: '/redirect/status',
        meta: {
            needLogin: false
        },
        component: () => import('@/view/redirectByStatus.vue')
    },
    {
        name: 'living/callback',
        path: '/living/callback',
        meta: {
            needLogin: false
        },
        component: () => import('@/view/livingCallback.vue')
    },
    {
        name: 'living/callback/dl',
        path: '/living/callback/dl',
        meta: {
            needLogin: false
        },
        component: () => import('@/view/livingCallbackForDL.vue')
    },
    ...loan,
    ...supplement,
    ...repay,
    ...apply,
    ...protocol,
    ...user,
    ...question,
    ...coupons,
    ...extension,
    ...daoliu,
    {
        name: 'sso',
        path: '/sso',
        component: () => import('@/view/sso.vue')
    }, {
        name: 'duoqidai-deny',
        path: '/duoqidai/deny',
        meta: {
            needLogin: true
        },
        component: () => import('@/view/duoqidai/deny.vue')
    }, {
        name: 'hybird-redirect',
        path: '/hybird/redirect',
        component: () => import('@/view/hybird/redirect2Native.vue')
    }, {
        name: 'download',
        path: '/download',
        component: () => import('@/view/download/download.vue')
    },
    {
        name: 'landing-fenqi',
        path: '/landing/fenqi',
        component: () => import('@/view/landingFenqi.vue')
    }
]
